import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { seriesOtherScmpSeriesContent$key } from "scmp-app/queries/__generated__/seriesOtherScmpSeriesContent.graphql";

import { Container, CoverImage, Headline, StyledCoverEntityLink, StyledEntityLink } from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: seriesOtherScmpSeriesContent$key;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
  topicLinkVariant,
}) => {
  const content = useFragment(
    graphql`
      fragment seriesOtherScmpSeriesContent on Content {
        entityId
        urlAlias
        ...entityLink
        ...hooksContentItemProvidersContent
          @arguments(withCoverImage: true, withCoverImageSize80x80: true, withHeadline: true)
      }
    `,
    reference,
  );
  const providers = useContentItemProviders(content, topicLinkVariant);
  const headline = providers.headline({ preferSocialHeadline: true });

  return (
    <Container className={className} ref={ref}>
      <StyledEntityLink
        onClick={() => onClick?.(content.entityId, content.urlAlias)}
        reference={content}
      >
        <Headline>{headline}</Headline>
      </StyledEntityLink>

      <StyledCoverEntityLink
        onClick={() => onClick?.(content.entityId, content.urlAlias)}
        reference={content}
      >
        <CoverImage>
          {providers.coverImage({
            responsiveVariants: {
              desktopUp: "size80x80",
              mobileUp: "size80x80",
              tabletUp: "size80x80",
            },
          })}
        </CoverImage>
      </StyledCoverEntityLink>
    </Container>
  );
};

Component.displayName = "ContentItemSeriesOtherScmpSeries";

export const ContentItemSeriesOtherScmpSeries = Component;
